/**
 * @file http Response 数据格式处理
 * @author svon.me@gmail.com
 */


import safeGet from "@fengqiaogang/safe-get";

import type {AxiosResponse} from "axios";

export const response = function <T = object>(res: AxiosResponse): T | undefined {
  return safeGet<T>(res, 'data');
}

export const autoResList = function (): object {
  return {
    code: 200,
    msg: "",
    rows: [],
    total: 0
  };
}